module.exports = __webpack_public_path__ + "img/pic_germany_07.103df3a3.jpg";